import {
    MILITARY_VARIANT,
    STC_VARIANT,
    collection,
} from "../_variants/index.js";

import {
    checkDesignChangeJobCards
} from "../DesignChanges/actions.js";
import { pad } from "../../../utils";
import { responsibleEngineer } from "../../standardFields.js";

/**
 * Resolve the project variant from a JobCard `ParentLocation` string
 * (e.g. "Database/DesignChanges/" or "Database/MilitaryDesignChanges/").
 * Defaults to STC for any non-matching / legacy value.
 */
const variantFromParentLocation = (parentLocation = "") =>
    parentLocation.includes("Military") ? MILITARY_VARIANT : STC_VARIANT;

export const addJobCard = ({ form, pageItem, store, meta, db }) => {
    form.setConfig({
        "title": "Add Job Card",
        "type": "push",
        "location": "Database/JobCards",
        "fields": [{
            "label": "Title",
            "name": "Title",
            "divClass": "col-span-3",
            "type": "text"
        },
            responsibleEngineer,
        {
            "label": "Card Colour",
            "type": "dropdown",
            "name": "Type",
            "dropdownData": ["Yellow", "Blue"].map(i => ({ id: i, label: i }))
        }
        ],
        async preSubmitHook({ db }) {
            const count = await db.utils.allocateCount("counts/cards/count");
            return {
                "Cancelled": false,
                "Commercial": pageItem.Parent,
                "CommercialID": pageItem.ParentID,
                "Date": {
                    "Cancelled": "N/A",
                    "Created": (new Date()).toISOString(),
                    "Signedoff": {
                        "Auditor": "Not Checked",
                        "Engineer": "Not Checked",
                        "TechnicalSecretary": "Not Checked",
                    }
                },
                "Number": `C.${pad(count, 4)}`,
                "Parent": pageItem.Number,
                "ParentID": pageItem.ID,
                "ParentLocation": `Database/${meta.ParentType}/`,
                "ParentType": meta.ParentType,
                "Signedoff": {
                    "Auditor": false,
                    "Engineer": false,
                    "TechnicalSecretary": false
                },
                "Stage": "Awaiting Technical Secretary Check"
            }
        },
        async postSubmitHook({  newData }){
            await db.set(`Database/${meta.ParentType}/${pageItem.ID}/JobCards/${newData.ID}`, true);
            await db.set(`Database/Commercials/${newData.CommercialID}/JobCards/${newData.ID}`, true);
            if(meta.ParentType === "DesignChanges") {
                await checkDesignChangeJobCards(db, pageItem.ID);
            }
        }
    });
    form.getDropdownData();
    form.toggle();
};

export const editJobCard = ({ form, item }) => {
    form.setValues(item);
    form.setConfig({
        "title": "Edit Job Card",
        "type": "update",
        "location": `Database/JobCards/${item.ID}`,
        "fields": [{
            "label": "Title",
            "name": "Title",
            "divClass": "col-span-3",
            "type": "text"
        },
            responsibleEngineer
        ],
        preSubmitHook() {
            return {
            }
        }
    });
    form.getDropdownData();
    form.toggle();
};

export const addJobCardFinding = ({ form, pageItem, store }) => {
    form.setConfig({
        "title": "Add Job Card Finding",
        "type": "push",
        "location": "Database/JobCardFindings",
        "fields": [{
            "label": "test",
            "name": "test",
            "type": "text",
            "divClass": "col-span-3"
        }, {
            "label": "Issue",
            "name": "Comment",
            "type": "richtext",
            "divClass": "col-span-3"
        }],
        preSubmitHook() {
            return {
                "JobCardID": pageItem.ID,
                "Number": `CF-${pad(store.state.counts.database.finding.count)}`,
                "Date": {
                    "Created": new Date().toISOString(),
                    "Signedoff": "N/A",
                    "Cancelled": "N/A"
                },
                "Signedoff": false,
                "Cancelled": false,
                "Parent": pageItem.Parent,
                "ParentID": pageItem.ParentID,
                "ResponsibleEngineer": pageItem.ResponsibleEngineer,
                "Colour": pageItem.Type,
                "AddedBy": pageItem.Signedoff.TechnicalSecretary ? "Auditor" : "Technical Secretary"
            }
        }
    });
    form.toggle();
};

export const editJobCardFinding = ({ form, item, store }) => {
    form.setValues({
        "Comment": item.Comment
    });
    form.setConfig({
        "title": "Update Job Card Finding",
        "type": "update",
        "location": `Database/JobCardFindings/${item.ID}`,
        "fields": [{
            "label": "Issue",
            "name": "Comment",
            "type": "richtext",
            "divClass": "col-span-3"
        }]
    });
    form.toggle();
};

export const cancelJobCard = ({ form, item }) => {
    form.setValues(item);
    form.setConfig({
        "title": "Cancel Job Card",
        "description": `Are you sure you want to cancel Job Card ${item.Number}?`,
        "submitButtonLabel": "Yes, Cancel Job Card",
        "submitButtonClass": "cancel",
        "type": "update",
        "location": `Database/JobCards/${item.ID}`,
        preSubmitHook() {
            return {
                "Cancelled": true
            }
        }
    });
    form.toggle();
};

export const jobCardSignoffCheckList = (type, typeResponsibilities) => async ({ form, item, store, db }) => {

    await db.store(`Database/${typeResponsibilities}`, store);
    await db.store("users", store);

    const requiredChecks = Object.values(store.state[`Database/${typeResponsibilities}`] || {}).filter(i => {
        return i.Colours.includes(item.Type.split(" ")[0]);
    }).map(i => {
        return {
            "type": "dropdown",
            "required": true,
            "label": i.Responsibility,
            "name": `${typeResponsibilities}[${i.ID}]`,
            "formStep": 1,
            "dropdownData": [{
                "label": "Yes",
                "id": "Yes"
            }, {
                "label": "N/A",
                "id": "N_A"
            }]
        };
    });

    const storedTime = (await db.once(`Database/JobCards/${item.ID}/Time`)) || {};

    const usersTime = Object.values(store.state.users).filter(i => i.main).map(i => {
        return {
            "label": `${i.name} Time`,
            "name": `Time/${i.key}`,
            "type": "number",
            "key": i.key,
            "formStep": 2
        };
    }).sort((a, b) => {
        return a.label.localeCompare(b.label);
    });

    let vals = {
        ...(Object.keys(item[typeResponsibilities] || {}).reduce((acc, i) => {
            return {
                [`${typeResponsibilities}[${i}]`]: item[typeResponsibilities][i] || null,
                ...acc,
            }
        }, {})),
        ...item[typeResponsibilities],
        ...Object.fromEntries(usersTime.map(i => [i.name, parseInt(storedTime[i.key] || 0) ?? 0]))
    };
    console.log(vals);
    form.setValues(vals);

    form.setConfig({
        "title": `${type} Signoff Checklist`,
        "type": "update",
        "location": `Database/JobCards/${item.ID}/`,
        "isSteppedForm": true,
        "fields": [
            ...requiredChecks, 
            ...usersTime
        ],
        async postSubmitHook() {
            await db.set(`Database/JobCards/${item.ID}/Date/Signedoff/${type}`, new Date().toISOString());
            await db.set(`Database/JobCards/${item.ID}/Signedoff/${type}`, true);
            if(item.ParentLocation.includes("DesignChanges")) {
                await checkDesignChangeJobCards(db, item.ParentID, variantFromParentLocation(item.ParentLocation));
            }
            
        }
    });
    form.getDropdownData();
    form.toggle();
};

/**
 * Build the seed Yellow Card for a newly-created Design Change.
 *
 * The variant determines `ParentLocation`, so signoff hooks (which read
 * `ParentLocation` to decide whether to recompute the parent DC's completion
 * state) navigate to the correct collection.
 *
 * @param {object} args
 * @param {object} args.store
 * @param {object} args.db
 * @param {object} args.parent  - the Design Change record
 * @param {import("../_variants/index.js").Variant} [args.variant=STC_VARIANT]
 */
export const createBasicYellowCard = async ({ db, parent, variant = STC_VARIANT }) => {
    const count = await db.utils.allocateCount("counts/cards/count");
    return {
        "Number": `C.${pad(count, 4)}`,
        "Cancelled": false,
        "Commercial": parent.Parent,
        "CommercialID": parent.ParentID,
        "Date": {
            "Cancelled": "N/A",
            "Created": new Date().toISOString(),
            "Signedoff": {
                "Auditor": "Not Checked",
                "Engineer": "Not Checked",
                "TechincalSecretary": "Not Checked"
            }
        },
        "ID": parent.ID,
        "Parent": parent.Number,
        "ParentID": parent.ID,
        "ResponsibleEngineer": parent.ResponsibleEngineer,
        "ParentLocation": `${collection(variant, "DesignChanges")}/`,
        "Title": parent.Title,
        "Signedoff": {
            "Auditor": false,
            "Engineer": false,
            "TechincalSecretary": false
        },
        "Stage": "Awaiting Technical Secretary Check",
        "Type": "Yellow Card",
    };
};

export const createBasicGreenCard = async ({ db, parent }) => {
    const count = await db.utils.allocateCount("counts/cards/count");
    return {
        "Number": `C.${pad(count, 4)}`,
        "Cancelled": false,
        "Commercial": "00000",
        "CommercialID": "--new00000",
        "Date": {
            "Cancelled": "N/A",
            "Created": new Date().toISOString(),
            "Signedoff": {
                "Auditor": "Not Checked",
                "Engineer": "Not Checked",
                "TechincalSecretary": "Not Checked"
            }
        },
        "ID": parent.ID,
        "Parent": parent.Number,
        "ParentID": parent.ID,
        "ResponsibleEngineer": "Needs Assigning",
        "ParentLocation": "Database/DesignChanges/",
        "Title": parent.Title,
        "Signedoff": {
            "Auditor": false,
            "Engineer": false,
            "TechincalSecretary": false
        },
        "Stage": "Awaiting Technical Secretary Check",
        "Type": "Green Card",
    };
};

export const createBasicRedCard = async ({ db, parent, variant = STC_VARIANT }) => {
    const count = await db.utils.allocateCount("counts/cards/count");
    return {
        "Number": `C.${pad(count, 4)}`,
        "Cancelled": false,
        "Commercial": parent.Number,
        "CommercialID": parent.ID,
        "Date": {
            "Cancelled": "N/A",
            "Created": new Date().toISOString(),
            "Signedoff": {
                "Auditor": "Not Checked",
                "Engineer": "Not Checked",
                "TechincalSecretary": "Not Checked"
            }
        },
        "ID": parent.ID,
        "Parent": parent.Number,
        "ParentID": parent.ID,
        "ResponsibleEngineer": parent.ResponsibleEngineer,
        "ParentLocation": `${collection(variant, "FlightConditions")}/`,
        "Title": parent.Title,
        "Signedoff": {
            "Auditor": false,
            "Engineer": false,
            "TechincalSecretary": false
        },
        "Stage": "Awaiting Technical Secretary Check",
        "Type": "Red Card",
    };
}
